import { ChangeDetectionStrategy, Component, ViewChild, Injector } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { PermissionFacade } from '../../../../../../../modules/permission/facades/permission.facade';
import { UserModel } from '../../../../../../../models/user-permissions.model';
import { ViewColumnComponent } from '../../../../../../../view-column.component';
import { AppConfig } from '../../../../../../../visa';
import { Observable, zip } from 'rxjs';
import { SubSink } from 'subsink2';
import { PermissionStates } from '../../../../../permission-controller/root';
import { UserPermActions } from '../../../../../user-permissions-controller/actions';
import { UserPermSelectors } from '../../../../../user-permissions-controller/selectors';
import { UserPermStates } from '../../../../../user-permissions-controller/states';
import { TranslateService } from "@ngx-translate/core";

interface LocalState {
  deactivateReturn: boolean;
  deactivateList: boolean;
  deactivateAdd: boolean;
  selectedIndex: number;
}

@Component({
  selector: 'app-user-permission-role-details',
  templateUrl: './user-permission-role-details.component.html',
  styleUrls: ['./user-permission-role-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore]
})
export class UserPermissionRoleDetailsComponent extends ViewColumnComponent {


  @ViewChild(MatTabGroup, {static: true}) matTab: MatTabGroup;

  protected readonly index = 2;
  private localState: LocalState;

  // info. about previous local states
  prevIndex: number;
  private prevLocalState: any;

  // initialise local states
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateReturn$ = this.componentStore.select(state => state.deactivateReturn);
  readonly selectedIndex$ = this.componentStore.select(state => (state.selectedIndex));
  readonly deactivateAdd$ = this.componentStore.select(state => state.deactivateAdd);

  // api visa
  apiVisa = AppConfig.apiVisa;

  toggleColumn$: Observable<boolean>;

  // subSink is to ensure all subscribe calls are unsubscribed to once the component is destroyed
  private subSink = new SubSink;

  public form: FormGroup;

  currentIndexTab: number;

  formDisabled: boolean = false;

  currentUser: UserModel;
  selectedUser: UserModel;
  readonly selectedRole$ = this.store.select(UserPermSelectors.selectSelectedRole)

  //translation variable
  title: string;
  details_text: string;
  code_text: string;
  name_text: string;
  permission_set_listing_text: string;
  back_button: string;

  constructor(
    private fb: FormBuilder,
    private store: Store<PermissionStates>,
    private viewColFacade: PermissionFacade,
    private readonly componentStore: ComponentStore<LocalState>,
    private injector: Injector
  ) {
    super();
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.title = res.view_role_details;
        this.details_text = res.details;
        this.code_text = res.code;
        this.name_text = res.name;
        this.permission_set_listing_text = res.permission_set_listing;
        this.back_button = res.back_button;
      });
    } else {
      this.title = 'View Role Details';
      this.details_text = 'Details';
      this.code_text = 'Code';
      this.name_text = 'Name';
      this.permission_set_listing_text = 'Permission Set Listing';
      this.back_button = 'Back';
    }
  }

  /**
   * Lifecycle method: Called when the component is first initialised.
   */
  ngOnInit() {
    this.subSink.sink = this.localState$.subscribe(a => {
      this.localState = a;
      this.componentStore.setState(a);
    });

    this.toggleColumn$ = this.viewColFacade.toggleColumn$;
    this.subSink.sink = this.viewColFacade.prevIndex$.subscribe(resolve => this.prevIndex = resolve);
    this.subSink.sink = this.viewColFacade.prevLocalState$().subscribe(resolve => this.prevLocalState = resolve);

    this.form = this.fb.group({
        code: [''],
        name: [''],
    })

    this.subSink.sink = this.selectedRole$
    .subscribe(selectedRole => {
      // set form values
      this.form.patchValue({
        code: selectedRole.app_mst_role.code,
        name: selectedRole.app_mst_role.name
      });
      // disable form accordingly
      // this.isReadOnly = this.disableForm()
    })

  }

  goToPermSetDetailAndPermSetLine(permSetEntity) {
    console.log("PermSetDetailAndPermSetLine");

    // dispatch ngrx action
    this.store.dispatch(UserPermActions.selectPermSet({permSet: permSetEntity}));

    if (!this.localState.deactivateList) {
      this.viewColFacade.updateInstance(this.index,
        {
          ...this.localState,
          deactivateAdd: false,
          deactivateList: false,
          deactivateReturn: true,
        });
      // trigger the next view column
      this.viewColFacade.onNextAndReset(this.index, 7);
    }
  }

  goToCreatePermSet() {
    console.log("CreatePermSet");

    // deactivate return, add and list in this component
    this.viewColFacade.updateInstance(this.index,
      {
        ...this.localState,
        deactivateAdd: true,
        deactivateList: false,
        deactivateReturn: true,
      });
    // trigger the add permission set component to be shown
    this.viewColFacade.onNextAndReset(this.index, 3);
  }

  /**
   * Return to the previous drawer/view column.
   */
   onReturn() {
    this.viewColFacade.updateInstance(this.prevIndex, {
      ...this.prevLocalState,
      deactivateReturn: false,
      deactivateAdd: false
    });
    this.viewColFacade.onPrev(this.prevIndex);
  }

  /**
   * Lifecycle method: Called when this component is destroyed.
   */
  ngOnDestroy() {
    if (this.matTab) {
      this.viewColFacade.updateInstance(this.index, {
        ...this.localState,
        selectedIndex: this.matTab.selectedIndex
      });
    }
    this.subSink.unsubscribe();
  }

}
